import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { ExtensionDataClient } from './extension-data-client.js';

export function useExtensionDataClient() {
  const httpClient = useHttpClient({ type: 'backoffice' });
  return useMemo(() => new ExtensionDataClient(httpClient), [httpClient]);
}
